import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UserMasterService } from "../../Services/user-master.service";
import { UserMaster } from "../../Model/user-master";
import { NgxSmartModalService } from "ngx-smart-modal";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";

import { ToastrService } from "ngx-toastr";
import { ComponentSecurityService } from "src/app/Main/Services/component-security.service";
import Swal from "sweetalert2";
import { EmployeeMasterService } from "../../Services/employee-master.service";
import { EmployeeMasterValidators } from "./employee-master-validators";

@Component({
  selector: "employee-master-revisions",
  templateUrl: "./employee-master-revisions.component.html",
  styleUrls: ["./employee-master-revisions.component.css"],
})
export class EmployeeMasterRevisionsComponent implements OnInit {
  public factors: UserMaster[];
  public columnDefs = [];
  public rowData = [];
  private gridApi;
  private gridColumnApi;
  private gridOptions;
  private defaultColDef;
  private rowSelection;
  private crudAction;
  public form: FormGroup;
  public canUpdateForm: boolean;
  public clicked: boolean = false;
  public userMaster1 = [];

  constructor(
    private service: EmployeeMasterService,
    public ngxSmartModalService: NgxSmartModalService,
    private employeeMasterValidators: EmployeeMasterValidators,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private securityService: ComponentSecurityService
  ) {
    this.defaultColDef = { sortable: true, filter: true };
    this.rowSelection = "single";
    this.createFormGroup();
    this.createGridColumnDefs();
  }

  @ViewChild("employeeNumber", { static: true })
  employeeNumberField: ElementRef;

  ngOnInit() {
    // Get grid data
    this.service.getAll().subscribe(
      (response) => {
        if (response.length > 0) {
          this.rowData = response;
        } else {
          this.rowData = null;
          this.toastr.warning("No records found", "Warning");
        }
      },
      (error) => {
        this.toastr.error("Unexpected error occurred", "Error");
      }
    );

    // Get form security
    this.securityService
      .canUpdate(this.constructor.name, localStorage.getItem("user"))
      .subscribe(
        (response) => {
          if (response.length > 0) this.canUpdateForm = true;
          else {
            this.canUpdateForm = false;
          }
        },
        (error) => {
          this.canUpdateForm = false;
        }
      );
  }

  createFormGroup() {
    this.form = this.fb.group(
      {
        employeeNumber: new FormControl(null, [Validators.required]),
        firstName: new FormControl(null, [Validators.required]),
        lastName: new FormControl(null, [Validators.required]),
        department: new FormControl(null, [Validators.required]),
        plant: new FormControl(null, [Validators.required]),
      },
      {
        validator: this.employeeMasterValidators.shouldBeUnique.bind(this),
      }
    );
  }

  createGridColumnDefs() {
    this.columnDefs = [
      {
        headerName: "Employee#",
        field: "employeeNumber",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Last Name",
        field: "lastName",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "First Name",
        field: "firstName",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Department",
        field: "department",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Plant",
        field: "plant",
        filter: "agTextColumnFilter",
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    setTimeout(() => this.employeeNumberField.nativeElement.focus());
  }

  onSelectionChanged(event) {
    // only open the window of row selected
    if (event.node.selected) {
      this.ngxSmartModalService.setModalData(
        this.gridApi.getSelectedRows()[0],
        "myModal",
        true
      );
      this.crudAction = "Update";
      this.loadInitialFormValues();
      this.ngxSmartModalService.getModal("myModal").open();
      setTimeout(() => this.employeeNumberField.nativeElement.focus());
    }

    // capture the event, so deselectall can be call when window closed
    this.gridOptions = event;
  }

  export() {
    let params = {
      fileName: "EmployeeMaster",
      allColumns: true,
    };
    this.gridApi.exportDataAsExcel(params);
  }

  loadInitialFormValues() {
    // If field is loading a zero, make it blanks
    this.form.patchValue({
      employeeNumber: this.gridApi.getSelectedRows()[0]["employeeNumber"],
      firstName: this.gridApi.getSelectedRows()[0]["firstName"],
      lastName: this.gridApi.getSelectedRows()[0]["lastName"],
      department: this.gridApi.getSelectedRows()[0]["department"],
      plant: this.gridApi.getSelectedRows()[0]["plant"],
    });
    this.clicked = false;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  modalAction() {
    switch (this.crudAction) {
      case "Update":
        this.service.update(this.form.value).subscribe(
          (response) => {
            if (response["success"] == "true")
              this.toastr.success("Record updated", "Success");
            this.service.getAll().subscribe((data) => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          (error) => {
            this.toastr.error("Record not updated", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();
        break;
      case "Create":
        this.service.create(this.form.value).subscribe(
          (response) => {
            if (response["success"] == "true")
              this.toastr.success("New record added", "Success");
            this.service.getAll().subscribe((data) => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          (error) => {
            this.toastr.error("Record not added", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();

        break;
      case "Delete":
        this.service.delete(this.form.get("employeeNumber").value).subscribe(
          (response) => {
            this.toastr.success("Record deleted", "Success");
            this.service.getAll().subscribe((data) => {
              this.rowData = data;
              this.gridApi.setRowData(this.rowData);
            });
          },
          (error) => {
            this.toastr.error("Record not deleted", "Error");
          }
        );
        this.ngxSmartModalService.get("myModal").close();
        break;
    }
  }

  close() {
    if (typeof this.gridOptions != "undefined")
      this.gridOptions.api.deselectAll();
  }

  create() {
    this.crudAction = "Create";
    this.ngxSmartModalService.resetModalData("myModal");
    this.form.reset();
    this.clicked = false;
    this.ngxSmartModalService.getModal("myModal").open();
    setTimeout(() => this.employeeNumberField.nativeElement.focus());
  }

  delete() {
    this.crudAction = "Delete";
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        this.modalAction();
      }
    });
  }
}
